export class State {
    Id:number=0;
    Title:string;
    Milestone:Milestones = Milestones.Started;
    Color:string ="#ffffff";
    Order:number;
}

export enum Milestones
{
    Started,
    Approved,
    Closed,
    Pending
}
